module.exports = __webpack_public_path__ + "img/00048.3072c9f5.webp";